import React, { useEffect } from "react";
import { useUnifiedService } from "../../../utilities/contexts/UnifiedServiceContext";
import UnitToggle from "../../shared/UnitToggle";

const UnifiedHeightInputStep: React.FC = () => {
  const { serviceInterface, serviceConfig, bodyMeasurement } = useUnifiedService();
  const { setCanProceedToNextStep } = serviceInterface;
  const { height, selectedUnit, displayValue, getValidationProps, handleHeightChange, handleUnitChange } = bodyMeasurement;

  const { configuration } = serviceConfig;

  useEffect(() => {
    const validationProps = getValidationProps();
    const numericValue = displayValue ? Number(displayValue) : null;

    let canProceed = false;
    if (height !== null && height > 0 && displayValue !== null && displayValue !== "" && numericValue !== null) {
      canProceed = numericValue >= validationProps.min && numericValue <= validationProps.max;
    }

    setCanProceedToNextStep(canProceed);
  }, [height, displayValue, getValidationProps]);

  if (!configuration?.requiresHeight) {
    return (
      <div className="flex items-center justify-center p-8">
        <p className="text-gray-500">Height input not required for this service</p>
      </div>
    );
  }

  const validationProps = getValidationProps();
  const numericValue = displayValue ? Number(displayValue) : null;
  const isValidRange = numericValue !== null && numericValue >= validationProps.min && numericValue <= validationProps.max;

  return (
    <div className="flex flex-col items-center w-full gap-4">
      <div className="text-center">
        <h2 className="mb-1 text-2xl font-medium text-secondary">Enter Your Height</h2>
        <p className="text-gray-600">Please provide your height for accurate measurements</p>
      </div>

      <div className="w-full max-w-md p-4 bg-white border border-gray-200 shadow-sm rounded-xl">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-3">
            <div className="relative">
              <input
                type="number"
                value={displayValue || ""}
                onChange={handleHeightChange}
                min={validationProps.min}
                max={validationProps.max}
                step={validationProps.step}
                placeholder={`Enter height in ${selectedUnit}`}
                className="w-full px-4 py-3 pr-32 text-sm transition-colors border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
              />

              <div className="absolute transform -translate-y-1/2 top-1/2 right-3">
                <UnitToggle selectedUnit={selectedUnit} onUnitChange={handleUnitChange} size="sm" />
              </div>
            </div>

            {displayValue && !isValidRange ? (
              <div className="text-xs text-red-600">
                Please enter a height between {validationProps.min} and {validationProps.max} {selectedUnit}
              </div>
            ) : (
              <div className="text-xs text-gray-500">
                Valid range: {validationProps.min} - {validationProps.max} {selectedUnit}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnifiedHeightInputStep;
